// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"EmailVerification-module--textContainer--2xNsD","text":"EmailVerification-module--text--3RD2P"};